<template>
  <li class="search-filters__option">
    <a
      href="#"
      class="search-filters__option-link"
      rel="nofollow"
      @click.prevent="redirectToCategory"
    >
      {{ $t(`search.product_type_codes.${filter}`) }}</a
    >
  </li>
</template>

<script>
export default {
  name: 'SearchFiltersOption',
  props: {
    filter: {
      type: String,
      required: true,
    },
    quantity: {
      type: Number,
      required: true,
    },
  },
  methods: {
    redirectToCategory() {
      this.$emit('change')

      const category = this.filter === 'everything' ? '' : this.filter
      const query = this.$route.query
      delete query.page
      this.$router.push({
        path: this.$route.path,
        query: { ...query, category },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.search-filters__option {
  display: block;
  line-height: 30px;
  font-size: 13px;

  &.search-filters__option--active a {
    color: #333;
    font-weight: bold;
  }

  &,
  a {
    text-decoration: none;
  }
}

.search-filters__option-link {
  color: #555;
}

@media (max-width: $screen_larger) {
  .search-filters__option {
    text-indent: 15px;
    padding-right: 15px;
    line-height: 40px;
    border-bottom: 1px solid $color_gray;

    &.search-filters__option--active a {
      border: none;
      color: $color_pink;
      box-shadow: inset 4px 0 0 $color_pink;
    }

    &,
    a {
      display: block;
    }
  }

  .search-filters__option {
    a:hover {
      color: #000;
    }

    .search-filters__option--active {
      a {
        padding-bottom: 2px;
        border-bottom: 2px solid $color_pink;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}
</style>
